import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import DailyTravelChargesModal from "./daily-travel-charges-modal";
import { processAutoTravelCharges } from "../../../../api/menu/invoicing/actions";

class DailyTravelChargesButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = () => {
        const modalObj = {
            id: "daily-travel-charges-modal",
            modalSettings: {
                size: "sm"
            },
            header: "Daily Travel Charges",
            children: (
                <DailyTravelChargesModal
                    onProcess={(date) => {
                        this.props.processAutoTravelCharges(date, () => {
                            this.props.closeCustomModal(modalObj);
                        });
                    }}
                    onCancel={() => this.props.closeCustomModal(modalObj)}
                />
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            className,
            title
        } = this.props;

        return (
            <button
                className={className}
                onClick={this.handleClick}
            >
                {title}
            </button>
        );
    }
}

DailyTravelChargesButton.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    processAutoTravelCharges: bindActionCreators(processAutoTravelCharges, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(DailyTravelChargesButton);

